<template>
  <div id="change-password">
    <Spinner v-if="isLoading"/>
    <form>
      <h1>Αλλαγή κωδικού</h1>
      <span v-if="errorMsg">{{ errorMsg }}</span>

      <input id="old-password" type="password" v-model="old_password" required placeholder="Παλιός κωδικός" autofocus>
      <input id="password" type="password" v-model="password" placeholder="Κωδικός" required>
      <input id="password-confirm" type="password" v-model="password_confirmation" placeholder="Επιβεβαίωση Κωδικού" required>

      <button type="submit" class="sav-btn sav-btn-red full-width" @click="handleSubmit">
        Επιβεβαίωση
      </button>
      <a href="javascript:void(0)" @click="goBack" class="sav-btn sav-btn-link full-width align-center">Επιστροφή</a>
    </form>
  </div>
</template>

<script>
import axios from 'axios';
import Spinner from './Spinner.vue'

export default {
  components: {
		Spinner
  },
	data(){
		return {
			isLoading: false,
			apiUrl: this.$parent.apiUrl,
			old_password : "",
			password : "",
			password_confirmation : "",
			errorMsg: ""
		}
	},
	methods : {
		handleSubmit(e){
			e.preventDefault();
			
			if (this.old_password.length == 0 || this.password.length == 0  || this.password_confirmation.length == 0) {
				this.errorMsg = "Συμπληρώστε όλα τα πεδία"
			} else {
				if (this.password != this.password_confirmation) {
          this.errorMsg = "Δεν ταιριάζουν οι κωδικοί"
        } else {
          this.errorMsg = "";
					this.changePassword();
        }
			}
		},
		changePassword() {
			const vm = this;
			this.isLoading = true;
			let url = this.apiUrl + '/post/changePassword';

			let formData = {
				old_password: this.old_password,
				password: this.password,
				password_confirmation: this.password_confirmation,
				user: JSON.parse(localStorage.getItem('sav-erp-user')),
				token: this.$cookie.get('sav-erp-token'),
				refreshToken: this.$cookie.get('sav-erp-refresh-token')
			}

			let headers = { 
				headers: {
				'Content-type': 'application/json',
				}
			};

			axios.post(url, formData, headers)
				.then(response => {
					vm.isLoading = false;
					if (response.status == 200) {
						this.$cookie.set('sav-erp-token', response.data.token, { expires: '15m' });
						this.$router.push("/profile");
					} else {
						vm.errorMsg = response.data ? response.data : response.status + " - " + response.statusText;
					}
				})
				.catch(error => {
					let response = error.response;

					if (response.status == 401) {
						localStorage.removeItem('user');    
						vm.$cookie.delete('sav-erp-token');
						vm.$cookie.delete('sav-erp-refresh-token');
						vm.$router.push("/login");
					} else {
						vm.errorMsg = response.data ? response.data : response.status + " - " + response.statusText;
					}
					vm.isLoading = false;
				});
		},
		goBack: function () {
		this.$router.go(-1);
		}
	}
}
</script>

<style lang="scss">
@import "./../scss/_colors";

html, body, #app, #change-password {
  height: 100%;
}

#change-password {
  background-image: linear-gradient($blue, $blue 40%, white 40%, white);
  display: flex;
  justify-content: center;
  padding-top: 50px;
  align-items: flex-start;

  form {
    width: 500px;
    padding: 50px;
    background-color: white;
    box-shadow: 0 2px 9px rgba(0,0,0,.25);
    display: flex;
    flex-direction: column;

    h1 {
      margin-top: 0;
      margin-bottom: 40px;
      font-weight: normal;
    }

    span {
      margin-bottom: 20px;
      color: $red;
      font-weight: bold;
    }

    input {
      border: none;
      border-bottom: 2px solid $blue;
      margin-bottom: 30px;
      padding: 0;
      box-shadow: none;

      &::placeholder {
        color: $blue;
      }
    }

    button {
      margin-bottom: 20px;
    }
  }
}
</style>
